import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLink = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M7.64219 4.46254L8.87969 3.22504C9.40363 2.74749 10.0914 2.49019 10.8002 2.5066C11.5089 2.52301 12.1841 2.81186 12.6853 3.31315C13.1866 3.81443 13.4755 4.48959 13.4919 5.19832C13.5083 5.90705 13.251 6.59485 12.7734 7.11879L11.0047 8.88129C10.7498 9.13716 10.4469 9.34018 10.1133 9.47871C9.77974 9.61724 9.42212 9.68855 9.06094 9.68855C8.69976 9.68855 8.34214 9.61724 8.00858 9.47871C7.67502 9.34018 7.3721 9.13716 7.11719 8.88129",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M8.35434 11.5366L7.11684 12.7741C6.5929 13.2516 5.90509 13.5089 5.19636 13.4925C4.48763 13.4761 3.81248 13.1872 3.31119 12.686C2.80991 12.1847 2.52105 11.5095 2.50465 10.8008C2.48824 10.0921 2.74554 9.40425 3.22309 8.88031L4.99184 7.11781C5.24675 6.86194 5.54968 6.65891 5.88323 6.52039C6.21679 6.38186 6.57441 6.31055 6.93559 6.31055C7.29677 6.31055 7.65439 6.38186 7.98795 6.52039C8.3215 6.65891 8.62443 6.86194 8.87934 7.11781",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgLink;
